import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import moment from 'moment';
import { RegistroService } from '../../../services/registro.service';

@Component({
    selector: 'app-agenda-popup',
    templateUrl: './agenda-popup.component.html',
    styleUrls: ['./agenda-popup.component.scss'],
    standalone: false
})
export class AgendaPopupComponent implements OnInit {

  public agendaForm: UntypedFormGroup

  constructor(
    public _dialogRef: MatDialogRef<AgendaPopupComponent>,
    public _fb: UntypedFormBuilder,
    private _sharedService: SharedService,
    private _registroService: RegistroService,
    @Inject(MAT_DIALOG_DATA)
    private _dialogData: any
  ) {
    //creates the form with default values
    this.CreateAgendaForm(_dialogData.companyId, _dialogData.user);

    if (_dialogData.data !== null) {
      this.agendaForm.patchValue({
        Id: _dialogData.data.id,
        Fecha: _dialogData.data.fecha,
        Texto: _dialogData.data.texto,
        Usuario: _dialogData.data.autor,
        Asunto: _dialogData.data.asunto
      });
    }

  }

  ngOnInit(): void {
  }

  private CreateAgendaForm(companyId: number, user: string): void {
    this.agendaForm = this._fb.group({
      Id: [0],
      EmpresaId: [companyId],
      Fecha: ['', Validators.required],
      Texto: ['', Validators.required],
      Usuario: [user],
      Asunto: ['', Validators.required]
    })
  }

 
  private ConvertDateToStringSpanishFormat():UntypedFormGroup {      
    //This to avoid date reduce by 12 hours and when recieveing at the API  
    let getDate = this.agendaForm.get('Fecha').value
    let formatedStringDate = moment(getDate).format('MM/DD/YYYY')
    //remove refference and create a new form object
    let formObject = {...this.agendaForm.value} 
    formObject.Fecha = formatedStringDate
    return formObject
  }


  public onSubmit() {
    this.agendaForm.markAllAsTouched();
    this.agendaForm.updateValueAndValidity();


    if (this.agendaForm.valid) {
      //This to avoid date reduce by 12 hours and when recieveing in API       
      let updatedForm = this.ConvertDateToStringSpanishFormat()
      //add data  
      if (this.agendaForm.value.Id === 0) {
        this.AddAgenda(updatedForm)
      } else {
        this.UpdateAgenda(updatedForm)
      }
    }
  }

  cancel(submitSuccess: boolean) {
    this._dialogRef.close(submitSuccess == null ? false : submitSuccess);
  }

  private AddAgenda(updatedForm) {
    this._registroService.AddAgenda(updatedForm)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Guardado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al crear', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }

  private UpdateAgenda(updatedForm) {
    this._registroService.UpdateAgenda(updatedForm)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Actualizado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }



}
